
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"18","height":"19","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M5.25 4.25a5.254 5.254 0 014.74 3H18v4.5h-1.5v3H12v-3H9.99c-.855 1.815-2.7 3-4.74 3A5.256 5.256 0 010 9.5a5.256 5.256 0 015.25-5.25zm0 1.5C3.18 5.75 1.5 7.43 1.5 9.5c0 2.07 1.68 3.75 3.75 3.75a3.753 3.753 0 003.532-2.497l.173-.503H13.5v3H15v-3h1.5v-1.5H8.955l-.173-.503A3.754 3.754 0 005.25 5.75zm0 1.5A2.257 2.257 0 017.5 9.5a2.257 2.257 0 01-2.25 2.25A2.257 2.257 0 013 9.5a2.257 2.257 0 012.25-2.25zm0 1.5a.752.752 0 00-.75.75c0 .412.338.75.75.75S6 9.912 6 9.5a.752.752 0 00-.75-.75z","fill":"#585858"}})])
          )
        }
      }
    